export default __webpack_public_path__ + "static/Collaborative Canvas_white_bg_v2-90b10cf5fcf51a6d62dc639b7e412e6f.png";